// Funciones del módulo antiguo de Capacitaciones (validación de certificados).
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import { db } from "@/firebase";
import { doc, getDoc } from "firebase/firestore";
import moment from "moment";

export const funcionesCapacitaciones = {
  //OBTENER CAPACITACION POR ID
  async obtenerValidacionCapacitacion(id) {
    try {
      let capacitacion = null;
      const docRef = doc(db, "riskmann_capacitaciones", id);
      const docSnap = await getDoc(docRef);
      if (
        docSnap.exists() &&
        docSnap.data().registro.estado !== "Eliminado"
      ) {
        capacitacion = docSnap.data();
        capacitacion.fechas.inicio = docSnap.data().fechas.inicio
          ? moment(docSnap.data().fechas.inicio).format("DD/MM/YYYY")
          : "";
        capacitacion.fechas.fin = docSnap.data().fechas.fin
          ? moment(docSnap.data().fechas.fin).format("DD/MM/YYYY")
          : "";
      }
      let todayDate = new Date();
      let dd = todayDate.getDate();
      dd = dd < 10 ? "0" + dd : dd;
      let mm = todayDate.getMonth() + 1;
      mm = mm < 10 ? "0" + mm : mm;
      let yyyy = todayDate.getFullYear();
      let today = dd + "/" + mm + "/" + yyyy;

      // Convertir las fechas a objetos Date para comparar correctamente
      // eslint-disable-next-line no-inner-declarations -- funciona igual dentro del bloque
      function parseDate(str) {
        // str formato 'DD/MM/YYYY'
        const [day, month, year] = str.split("/").map(Number);
        return new Date(year, month - 1, day);
      }
      const fechaInicio = parseDate(capacitacion.fechas.inicio);
      const fechaFin = parseDate(capacitacion.fechas.fin);
      const fechaHoy = parseDate(today);
      // Validar que el estado NO sea "Cerrada" O que la fecha de hoy esté entre inicio y fin
      const estaAbiertaPorFecha =
        fechaHoy >= fechaInicio && fechaHoy <= fechaFin;
      return estaAbiertaPorFecha;
    } catch (error) {
      console.error("Error en obtenerValidacionCapacitacion:", error);
      return false; // En caso de error, no permitir acceso
    }
  },
};
